// https://so-zou.jp/web-app/tech/data/code/language.htm
const LOCALE_LIST = {
    ja: 'ja-JP',
    en: 'en-US',
    nl: 'nl-NL',
    fr: 'fr-FR',
    de: 'de-DE',
    it: 'it-IT',
    pt: 'pt-PT',
    es: 'es-ES',
    c2: 'zh-CN',
    zh: 'zh-TW',
    ko: 'ko-KR',
    ru: 'ru-RU',
    id: 'id-ID',
    pl: 'pl-PL',
    th: 'th-TH',
    tr: 'tr-TR',
    sv: 'sv-SE',
    ro: 'ro-RO',
    el: 'el-GR',
    cs: 'cs-CZ',
    nn: 'nb-NO',
    da: 'da-DK',
    fi: 'fi-FI',
    hu: 'hu-HU',
    uk: 'uk-UA',
    ms: 'ms-MY'
}

export function localeDateString(date, lg2) {
    const event = new Date(date)
    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    const locale = LOCALE_LIST[lg2]

    let dateString = ""
    try {
        dateString = event.toLocaleDateString(locale, options)
    } catch (e) {
        return date.split('-').join('/')
    }
    return dateString;
}